<div class="container">
    <p class="no-order-found-text">{{ "orderItemList.noOrder" | translate }}</p>
    <button mat-flat-button class="btn-primary-gradient" (click)="backToOrders()">
        {{ "orderItemList.button.back" | translate }}
    </button>
</div>
